import { createBrowserHistory } from "history";

const config = {
  basename: process.env.PUBLIC_URL,
};

export default createBrowserHistory(config);
